// extracted by mini-css-extract-plugin
module.exports = {"articleArea":"articleBase_articleArea__1xsAD","articleBaseArea":"articleBase_articleBaseArea__2Qthm"};